/*
 * before-after-slider.js — Elegant Lighters
 *
 * Drives the drag-to-compare widget in snippets/before-after-slider.liquid.
 * All interaction lives on a native range input, so pointer drag, click-to-jump
 * and arrow keys are handled by the browser; this only mirrors the value into a
 * CSS custom property that clips the "after" layer.
 *
 * Delegated at the document level so sections added or reordered in the theme
 * editor work without re-binding.
 */
(function () {
  function paint(input) {
    var root = input.closest('.ba-slider');
    if (root) root.style.setProperty('--ba-pos', input.value + '%');
  }

  function handle(event) {
    var input = event.target;
    if (input && input.classList && input.classList.contains('ba-slider__range')) paint(input);
  }

  document.addEventListener('input', handle);
  document.addEventListener('change', handle);

  function init(scope) {
    (scope || document).querySelectorAll('.ba-slider__range').forEach(paint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: sections re-render without a page load.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
